import VueScrollTo from 'vue-scrollto';
import { clamp, average } from '@/utils';
import { normalizeWheel } from '@/vendor/normalize-wheel';

const defaultOptions = {
  container: document.body,
  easing: 'ease-in',
  offset: 0,
  createRoutes: false,
  cancelable: false,
  threshold: 0.5,
  delay: 2000
};

export default {
  install(Vue, options) {
    options = { ...defaultOptions, ...options };
    const sections = [];
    let deltas = [];
    let scrolling = false;
    let auto = false;
    let current = 0;
    let lastScrollTime = new Date().getTime();
    let touchStart = 0;
    let offsetMobile = 0;
    let delayTimeout = null;
    options.onStart = () => {
      scrolling = true;
    };
    options.onDone = () => {
      scrolling = false;
    };
    options.onCancel = () => (scrolling = false);
    const router = options.router;

    document.body.addEventListener('wheel', handleScroll, { passive: false });
    document.body.addEventListener('touchstart', e => {
      touchStart = e.touches[0].clientY;
    });

    function handleTouch(event) {
      offsetMobile = touchStart - event.touches[0].clientY;
      event.deltaY = event.wheelDelta = Math.sign(offsetMobile) * -2;
      if (Math.abs(offsetMobile) > 8) return handleScroll(event);
    }
    document.body.addEventListener('touchmove', handleTouch, { passive: false, cancelable: true });

    router.afterEach(to => {
      if (auto) return (auto = false);
      const scrollOptions = { ...options };
      const matches = [...to.matched];
      Vue.nextTick(() => {
        let section = null;
        let path = null;
        while (!section && matches.length) {
          path = matches.pop().path;
          const id = routePathToId(path);
          section = document.getElementById(id);
        }
        if (section) {
          current = sections.findIndex(s => s.path === path);
          if (sections[current].onEnter)
            scrollOptions.onDone = () => {
              scrolling = false;
              sections[current].onEnter();
            };
          VueScrollTo.scrollTo(section, 500, scrollOptions);
        }
      });
    });

    Vue.directive('scroll-nav', {
      bind(el, binding) {
        const id = routePathToId(binding.value.path);
        el.id = id;
        sections.push({ path: binding.value.path, onEnter: binding.value.onEnter });
        if (options.createRoutes) addChildRoute(binding.value.path);
      }
    });

    function isCurrentPath(path) {
      if (router.currentRoute.path === '/' && path === '/') return true;
      const currentPath = router.currentRoute.path.replace(/\/+$/, '');
      return currentPath === path;
    }

    function handleScroll(e) {
      const wheel = normalizeWheel(e);
      const delta = Math.abs(wheel.spinY);
      e.stopPropagation();
      if (e.cancelable) e.preventDefault();
      if (delayTimeout) return false;
      const currentScrollTime = new Date().getTime();
      if (currentScrollTime - lastScrollTime > 200) {
        deltas = [];
        offsetMobile = 0;
      }
      lastScrollTime = currentScrollTime;
      if (delta < 0.01) return false;
      const direction = Math.sign(wheel.spinY);
      if (deltas.length > 149) deltas.shift();
      deltas.push(delta);
      if (scrolling || !isAccelerating()) return false;
      delayTimeout = setTimeout(() => {
        delayTimeout = null;
      }, options.delay);
      move(direction);
      return false;
    }

    function isAccelerating() {
      if (deltas.length <= 1) return true;
      const averageEnd = average(deltas, 10);
      const averageMiddle = average(deltas, 70);
      const delta = averageEnd - averageMiddle;
      return delta >= options.threshold;
    }

    function addChildRoute(path) {
      const { routes } = router.options;
      const route = routes.find(r => r.path === '/');
      if (!route.children) route.children = [];
      route.children = [...route.children, { path }];
      router.addRoutes([route]);
    }

    function routePathToId(path) {
      return (
        'route-' +
        path
          .substring(1)
          .split('/')
          .join('-')
      );
    }

    function move(direction) {
      current = clamp(current + direction, 0, sections.length - 1);
      if (!isCurrentPath(sections[current].path)) {
        router.push(sections[current].path);
      }
    }

    Vue.prototype.$scroll = {
      next() {
        move(1);
      },
      prev() {
        move(-1);
      }
    };
  }
};
